import { SHOW_KEYBOARD, GENERATE_DEVICE_ID } from '../constants/appConstants';

const initialState = { showKeyboard: false, vizioDeviceId: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_KEYBOARD:
      return { ...state, showKeyboard: action.payload };
    case GENERATE_DEVICE_ID:
      return { ...state, vizioDeviceId: action.payload };
    default:
      return state;
  }
};

export default reducer;
